import { AudioGraph } from "../AudioGraph";
import { AudioGraphNodeType } from "../AudioGraphNodeType";
import { AudioGraphNode } from "./AudioGraphNode";

export class BiquadFilter extends AudioGraphNode<BiquadFilterNode>
{
  constructor( graph:AudioGraph, id:number )
  {
    super( graph, id, AudioGraphNodeType.BiquadFilter );
  }

  protected _assignAudioNode()
  {
    this._node = this._context.createBiquadFilter();
  }

  setPeaking( frequency:number, q:number, gain:number )
  {
    this._node.type = "peaking";
    this._node.frequency.value = frequency;
    this._node.Q.value = q;
    this._node.gain.value = gain;
  }

  
  
}